export default __webpack_public_path__ + "static/media/pizza_puzzle.c6a77830.svg";